// extracted by mini-css-extract-plugin
module.exports = {"container":"demo-form-layout_container__dTSgH","content":"demo-form-layout_content__V0z35"};